const lan = {
  REDIRECT: "Omdirigerer...",
  RULE: {
    SERVICE_TYPE: "Vælg venligst servicetype",
    COUNTRY: "Vælg dit land eller din region",
    USERNAME: "Et brugernavn er påkrævet",
    EMAIL: "En e-mailadresse er påkrævet",
    EMAIL2: "Indtast venligst det korrekte e-mailformat.",
    PRODUCT: "Vælg din enhed",
    PRODUCTSN: "Indtast dit produkts serienummer",
    PRODUCTSN_LEN: "Indtast 12 til 15 bogstaver eller tal",
    BIRTHDAY: "En fødselsdag er påkrævet",
    REQUIRED: "Påkrævet",
  },
  SYS: {
    HEAD: "System",
    NOSERVICE:
      "Beklager, ASUS Chat er ikke tilgængelig for dit valgte land eller område.",
    CHECK_FILESIZE:
      "Kontroller størrelsen på billedet eller vedhæftningen. Begrænsning:",
    RECONNECTED: "Forbindelsesstatus er vendt tilbage til normal",
    UNABLE_SEND: "Kan ikke sende vedhæftningerne",
    NO_NETWORK: "Ingen internetforbindelse",
    NO_NETWORK_INFO:
      "Ingen internetforbindelse. Opret forbindelse til internettet, og prøv igen.",
  },
  IDLE: {
    HEAD: "Du har været inaktiv i et stykke tid. Vil du fortsætte chatten?",
    BUTTON: "Fortsæt",
  },
  DISCONNECT: {
    HEAD: "Chatten er afsluttet",
    BUTTON: "Afslut",
  },
  LAYOUT: {
    STEP_1: "Vælg produkt",
    STEP_2: "Servicevilkår",
    STEP_3: "Log ind",
    STEP_4: "Information",
    SELECT_SKILL: "Vælg produkt",
    PREV_STEP: "Forrige",
    NEXT_STEP: "Næste",
    NOTSET: "Ikke indstillet.",
    AGREEN: "Accepterer",
    NOTAGREEN: "Accepterer ikke",
    LEAVE: "Forlad",
    TYPE_HERE: "Skriv her",
    CHAT_DOWNLOAD:
      "Klik her for at gemme en kopi af din chat med ASUS kundeservice.",
  },
  COUNTRY: { SELECT_COUNTRY: "Vælg venligst tjenestens land eller region" },
  POLICY: {
    PRIVACY: "Politik om beskyttelse af personlige oplysninger",
    SAT_SURVEY: "Serviceaftale",
    CONFIRM_COUNTRY: {
      H1: "Kære ASUS kunde,",
      P1:
        "Du besøger nu ASUS Kundeservice for Norden, som er forskellig fra din nuværende region. Ifølge ASUS' garantibetingelser er ikke alle ASUS-produkter omfattet af ASUS' internationale garanti- og supporttjenester. Hvis ovenstående regionale websted, du besøger, ikke er den region, hvor du har købt dit ASUS-produkt, eller er forskellig fra din nuværende region, kan dette påvirke dine rettigheder. Du kan fortsætte med at bruge ASUS' online kundeservice for Danmark eller ændre ASUS' online kundeservice til din region.",
      P2: "",
      P3: "",
      B1: "Skift til ASUS",
      B2: "Hjemmeside",
      B3: "Fortsæt med at bruge",
    },
    BULLETIN: {
      HEAD: "Meddelelse om en vigtig besked",
      CONFIRM: "Jeg forstår",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "Udfyld venligst dine kontaktoplysninger",
    SURVEY_TYPE: "Vælg venligst servicetype",
    PROBLEM_BRIEF: "Hvordan vil du beskrive dit problem?",
    TYPE1: "Generelt spørgsmål",
    TYPE2: "Reparationsanmodning",
    TYPE3: "Teknisk support",
    TYPE4: "Garantianmodning",
    TYPE5: "Synspunkter og feedback",
    EC_TYPE1: "Produkt- og salgsoplysninger",
    EC_TYPE2: "Marketingbegivenhed",
    EC_TYPE3: "Forsendelses- og ordrestatus",
    EC_TYPE4: "Returservice",
    SIGNUPDATA: "Dine registreringsoplysninger",
    NAME: "Navn",
    TEL: "Telefonnummer",
    ORDER_NO: "Ordrenr.",
    BIRTHDAY: "Fødselsdag",
    LABEL_EMAIL: "E-mail",
    EMAIL: "E-mail",
    DEVICEINFO: "Dine produktoplysninger",
    DEVICENAME: "Produktnavn",
    MY_DEVICE: "Dit produkt",
    MY_DEVICE_SELECT: "Vælg dit produkt",
    MY_DEVICE_EMPTY: "Du har ingen enheder endnu.",
    LABEL_DEVICESN: "Serienummer",
    DEVICESN: "Produktets serienummer",
    DEVICESN_ERROR: "Det serienummer, du indtastede, er ugyldigt.",
    PREPARE: "Opretter chatrummet, gør klar til at chatte",
    START: "Start chatten",
    AGE_LIMIT: "Aldersgrænse",
    AGE_LIMIT_DESC: "Du opfylder ikke alderskravene for at bruge ASUS Chat",
    REPEAT_ENTRY: {
      H1: "Eksisterende chatrum registreret",
      P1:
        "Er du sikker på, at du vil starte en ny samtale? Når en ny samtale åbnes, afsluttes den gamle samtale.",
      B0: "Bekræft",
      B1: "Annuller",
    },
  },
  CONNECTTING: {
    P1: "Vent venligst et øjeblik, og luk ikke chatvinduet",
    P2: "ASUS Chat forbinder dig til en tilgængelig agent",
    NOTE: "Tip",
    BEFORE_LEAVE: "Er du sikker på, at du vil afslutte din ASUS Chat?",
    B0: "Afslut",
    B1: "Bliv og vent",
  },
  OFFLIEN: {
    OTHER_CONTACT: "Kontakt ASUS via andre kanaler",
    MAIL: "E-mail os",
    TEL: "Ring til os",
    CLOSE: "Luk",
  },
  WAITTING: {
    WATTING_NUM: "Position i køen",
    PEOPLE: "Kunde",
    NOTE: "Tip",
    BEFORE_LEAVEL: "Er du sikker på, at du vil forlade køen?",
    LEAVE_DESC: "Hvis du vil forlade køen, kan du afslutte chatten",
    LEAVE: "Afslut chatten",
    STAY: "Bliv i køen",
  },
  CHATROOM: {
    TYPING: "Agenten skriver...",
    HEAD: {
      CLOSE_AMD_SURVEY: "Forlad chatten",
      TERMINATE: "Afslut chatten",
    },
    FOOTER: { CHAT_FINISH: "Chatten er afsluttet" },
    FINISH:
      "Chatten er afsluttet. Har du brug for yderligere service eller support?",
    SAT_SURVEY: {
      SAT: "Tilfreds",
      DISSAT: "Utilfreds",
      SAT_CHOOSE: "Hvilken type tjenester? (flere)",
      HEAD: "Var du tilfreds med chatten?",
      DESC:
        "At lytte til din feedback er en drivkraft for vores kontinuerlige forbedring. Fortæl os, hvis du har forslag til ASUS Service eller Support.",
      OTHER_OPTION: "Andet",
      OTHER_REASON: "Udfyld venligst den anden årsag",
      SEND: "Send",
    },
    CLOSE: {
      TITLE: "Er du sikker på, at du vil afslutte chatten?",
      P1:
        'Klik på "Afslut" for at lukke vinduet. Hvis du har brug for at bruge chatten igen, skal du klikke på "Start ny chat".',
      B0: "Afslut",
      B1: "Annuller",
    },
  },
  ERROR: {
    H1: "Chatrummet findes ikke, eller chatten er allerede afsluttet",
    CLOSE: "Luk vinduet",
  },
  CHAT_END: {
    H1: "Mange tak, chatten er nu afsluttet",
    CLOSE: "Luk vinduet",
  },
  CHAT_CLOSE: {
    H1:
      "Din netværksforbindelse har været nede i mere end 300 sekunder, så vi har afsluttet denne samtale.",
    DESC:
      "Hvis du bruger et trådløst eller mobilt netværk, skal du flytte dig til et sted med et stærkere signal eller skifte til en kabelført netværksforbindelse. Vi beklager eventuelle gener",
    CLOSE: "Luk vinduet",
  },
  SURVEY_DONE: {
    H1: "Tak. Du har gennemført undersøgelsen om servicetilfredshed",
    P1:
      'Din feedback er en drivkraft for vores kontinuerlige forbedring. Tak fordi du tog dig tid til at udfylde undersøgelsen om servicetilfredshed. Hvis du har brug for yderligere service eller support, skal du klikke på "Start ny chat". Klik på "Luk vinduet" for at afslutte chatten, hvis vi har løst din forespørgsel',
    AGAIN: "Start ny chat",
    CLOSE: "Luk vinduet",
    YT_H1: "Opdag tips og teknisk knowhow med ASUS supportvideoer.",
    YT_H2: "Klik for at udforske!",
  },
  AGENT_OFFLINE: {
    H1:
      "Agentens internetforbindelse reagerer ikke; din chat er i øjeblikket afbrudt",
    H2:
      "Luk ikke vinduet. Vi arbejder hårdt på at genoptage chatten",
    DESC:
      'Du kan også vælge at afslutte chatten og starte undersøgelsen eller klikke på "Start ny chat", og vi vil straks tildele en ny agent til at fortsætte din chat. Vi beklager eventuelle gener',
    AGAIN: "Start ny chat",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "Kan ikke bruge kamera og mikrofon",
    H1: "Klar til at deltage?",
    P1:
      "For at ASUS' kundeservicepersonale kan hjælpe dig med at løse problemet mere effektivt, skal du tillade enheden at få adgang til dit kamera og din mikrofon for at deltage i videochatrummet, og sørg for, at din mobile netværksforbindelse er stabil og fungerer normalt",
    P2:
      "Efter adgang kan du stadig frit indstille linseomskifteren og mikrofonens lydløs.",
    VIDEO_STATE: "Videostatus",
    VIDEO_ON: "Tændt",
    VIDEO_OFF: "Slukket",
    AUDIO_STATE: "Lydstatus",
    AUDIO_ON: "Tændt",
    AUDIO_OFF: "Slukket",
    ENTER: "Deltag",
    HANGUP: {
      H1: "Læg på",
      P1: "Er du sikker på, at du vil lægge på videochatten?",
      CONFIRM: "Bekræft",
      CANCEL: "Annuller",
    },
    END: {
      H1: "Videoopkald er afsluttet",
      P1: "Tak, denne videochat er overstået, du kan lukke dette vindue.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Vælg produkt",
      STEP_2: "Servicevilkår",
      STEP_3: "Log ind",
      STEP_4: "Information",
      SELECT_SKILL: "Vælg produkt",
      WELCOME: "Velkommen",
      AGREE: "Accepter",
      START: "Start",
      CANCEL: "Annuller",
      WAIT: "Vent venligst",
      INPUT: "Indtast dit spørgsmål her",
      TRANSFER_TOAGENT: "Overfør til agent.",
      READMORE: "Du kan også henvise til følgende relaterede FAQ, tak.",
      COLLAPSE: "Skjul",
      INPUT_SN: "Indtast venligst serienummeret igen",
      YOU_MAY_ALSO: "Du vil måske også spørge:",
      FOR_FURTHER: "For yderligere oplysninger henvises til:",
      RECORDING: "Begynd venligst at tale...",
      RECORDING_NOT_SUPPORTED:
        "Din browser understøtter ikke talegenkendelse",
      RECORDING_NOT_FOUND:
        "Ingen optageenhed blev fundet. Kontroller din mikrofon og dine tilladelser.",
    },
    IS_COMPONENT_SN:
      "Input er komponentens serienummer, du skal indtaste det korrekte maskinens serienummer.",
    WARRANTY: {
      SERIES: "Produkttype",
      MODEL: "Produktnavn",
      SERIALNO: "Produktets serienummer",
      STATUS: "Garantistatus",
      DATE: "Garantiens udløbsdato",
    },
    HEAD: {
      LEAVE: "Forlad",
      CREATE_NEW: "Start forfra",
    },
    ENTRANCE: {
      POLICY: "Politik om beskyttelse af personlige oplysninger",
      AGREE: "Klik på Accepter for at starte samtalen",
    },
    MESSAGE: {
      WAIT: "Vent venligst, vi leder efter en løsning til dig.",
    },
    END: "Samtalen er afsluttet",
    END_MSG:
      "Vi er glade for at kunne tilbyde vores service. Du er velkommen til at kontakte os for fremtidig support.",
    END_SURVEY: "Tilfredshedsundersøgelse",
    END_SURVEY_MSG:
      "Vi er glade for at kunne tilbyde vores service. Du er velkommen til at kontakte os for fremtidig support.",
    BACKHOME: "Genstart samtalen",
    SURVEY: {
      DESC: "Bedøm venligst din oplevelse med ASUS' virtuelle assistent.",
      SAT: "Tilfreds",
      DISSAT: "Utilfreds",
      FEEDBACK: "Udfyld venligst din feedback.",
      SEND: "Send",
      BACK: "Annuller",
    },
    SURVEY_DISLIKE: {
      H1: "Hvorfor er du utilfreds med svaret?",
      P: "Din feedback hjælper os med at forbedre vores servicekvalitet.",
      BUTTON: "Send",
    },
    HISTORY: {
      TITLE: "Historik",
      AGO: "{hours} timer siden",
      CONTINUE: "Fortsæt chatten",
      CLOSE: "Samtalen er blevet lukket.",
      RESTART: "Genstart med virtuel assistent",
      NON_SERVICE: "Ikke-service timer",
      VIEW_HISTORY: "Klik for at se den seneste chat-historik.",
    },
  },
};
export default lan;
